import { useContext } from 'react';
import { BentoStreamContext } from '@/contexts/BentoStreamContext';
import { ContextOptions } from '@/contexts/BentoStreamContext/types';

export const useBentoStreamContext = (): ContextOptions => {
  return useContext<ContextOptions>(BentoStreamContext);
};
